import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "siteSearch" };
const _hoisted_2 = { class: "siteSearch-controls" };
const _hoisted_3 = {
    key: 0,
    class: "siteSearch-inputField"
};
const _hoisted_4 = { class: "siteSearch-indexes" };
const _hoisted_5 = {
    key: 0,
    class: "siteSearch-mbIndexes"
};
const _hoisted_6 = ["value", "selected"];
const _hoisted_7 = {
    key: 1,
    class: "siteSearch-adv"
};
const _hoisted_8 = { class: "siteSearch-adv-control for--tx" };
const _hoisted_9 = { class: "siteSearch-toggleTX" };
const _hoisted_10 = { class: "siteSearch-adv-control for--dates" };
const _hoisted_11 = {
    key: 0,
    class: "siteSearch-adv-dates"
};
const _hoisted_12 = { class: "siteSearch-adv-control for--sorting" };
const _hoisted_13 = ["value", "selected"];
const _hoisted_14 = ["value", "selected"];
const _hoisted_15 = ["value", "selected"];
const _hoisted_16 = {
    key: 2,
    class: "siteSearch-topicsCaps"
};
const _hoisted_17 = {
    key: 0,
    class: "siteSearch-results"
};
const _hoisted_18 = {
    key: 0,
    class: "siteSearch-results-meta"
};
const _hoisted_19 = { class: "siteSearch-results-header" };
const _hoisted_20 = { class: "siteSearch-results-headerTitle" };
const _hoisted_21 = ["href"];
const _hoisted_22 = { class: "siteSearch-results-resultsCount" };
const _hoisted_23 = {
    key: 0,
    class: "siteSearch-results-facets"
};
const _hoisted_24 = { class: "siteSearch-results-facet formBody" };
const _hoisted_25 = { class: "siteSearch-results-facetTitle" };
const _hoisted_26 = { class: "siteSearch-checkbox" };
const _hoisted_27 = ["checked", "onChange"];
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = { class: "siteSearch-hits" };
const _hoisted_30 = {
    key: 1,
    class: "buttonWrapper"
};
const _hoisted_31 = {
    key: 0,
    class: "siteSearch-nothingFound"
};
const _hoisted_32 = { key: 0 };
const _hoisted_33 = {
    key: 1,
    class: "siteSearch-prompt"
};
const _hoisted_34 = { class: "topicsModal-inputWrapper" };
const _hoisted_35 = { class: "topicsModal-choicesList" };
const _hoisted_36 = { class: "siteSearch-checkbox" };
const _hoisted_37 = ["checked", "onChange"];
const _hoisted_38 = ["innerHTML"];
import { computed, nextTick, onUnmounted, reactive, ref, shallowRef, watch } from 'vue';
import { theme } from '../../Theme';
import { ThemeButton, ThemeIcon, ThemeModal } from '../../components';
import { getStandAloneSearchArgsDefaults, indexesCardComponents, MIN_INPUT_LENGTH, getMultiSearchArgsDefaults, getTXIndexUid, getPrimeIndexUid, } from './SiteSearch';
import { Search } from '../../../layouts/Search/Search';
import { ThemeMediaSize } from '../../defs/types';
var SortBy;
(function (SortBy) {
    SortBy["Relevance"] = "relevance";
    SortBy["DateAsc"] = "timestamp:asc";
    SortBy["DateDesc"] = "timestamp:desc";
})(SortBy || (SortBy = {}));
export default /*@__PURE__*/ _defineComponent({
    __name: 'SiteSearch',
    props: {
        query: {},
        initialIndexUid: {},
        initialTopicsIds: {},
        initialStaticFacets: {},
        initialDateFrom: {},
        initialDateTo: {},
        linkToSearchPage: { type: Boolean },
        withoutInput: { type: Boolean },
        autoFocusInput: { type: Boolean },
        advanced: { type: Boolean }
    },
    emits: ["indexChange", "queryChange", "searchResult", "topicsChange", "staticFacetsChange", "dateFromChange", "dateToChange"],
    setup(__props, { emit: __emit }) {
        var _a, _b, _c, _d;
        const props = __props;
        const VueDatePicker = shallowRef();
        if (props.advanced) {
            // Lazy load datepicker, since it's quite heavy and only used in advanced search
            import('@vuepic/vue-datepicker').then(module => {
                VueDatePicker.value = module.default;
            });
        }
        const SortByLabels = {
            [SortBy.Relevance]: 'Relevans',
            [SortBy.DateAsc]: 'Datum stigande',
            [SortBy.DateDesc]: 'Datum fallande',
        };
        const api = theme().meiliSearchApi;
        const indexes = theme().json.meilisearch.indexes;
        const topicsModal = ref();
        const topicsModalInput = ref();
        const topicsState = reactive({
            search: '',
            selected: [],
        });
        const ownQueryInputEl = ref();
        const ownQuery = ref(props.query || '');
        const activeIndexUid = ref(props.initialIndexUid || null);
        const activeIndex = computed(() => indexes.find(i => i.uid === activeIndexUid.value));
        const results = ref([]);
        const hasResults = computed(() => { var _a; return ((_a = results.value) === null || _a === void 0 ? void 0 : _a.length) && results.value.some(res => { var _a, _b; return (_b = (_a = res.result) === null || _a === void 0 ? void 0 : _a.hits) === null || _b === void 0 ? void 0 : _b.length; }); });
        const state = reactive({
            searching: false,
            searchInQueue: false,
            mediaSize: theme().mediaSize,
        });
        let initialTopics = ((_a = props.initialTopicsIds) === null || _a === void 0 ? void 0 : _a.length) && ((_d = (_c = (_b = activeIndex.value) === null || _b === void 0 ? void 0 : _b.topicsData) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.length) ? {
            attribute: activeIndex.value.topicsData.attribute,
            selected: activeIndex.value.topicsData.values.filter(v => { var _a; return (_a = props.initialTopicsIds) === null || _a === void 0 ? void 0 : _a.includes(parseInt(v.id)); }) || [],
        } : null;
        const advancedArgs = reactive({
            isTitleExclusive: false,
            type: '',
            topicsFilter: initialTopics,
            dateFrom: new Date(props.initialDateFrom || '').getTime() || 0,
            dateTo: new Date(props.initialDateTo || '').getTime() || 0,
            sortBy: SortBy.Relevance,
            activeStaticFacets: (props.initialStaticFacets || []),
        });
        const query = computed(() => {
            var _a;
            const query = (_a = (props.withoutInput ? props.query : ownQuery.value)) === null || _a === void 0 ? void 0 : _a.trim();
            return (query === null || query === void 0 ? void 0 : query.length) && query.length >= MIN_INPUT_LENGTH ? query : '';
        });
        const sortArgs = computed(() => advancedArgs.sortBy === SortBy.Relevance ? {} : { sort: [advancedArgs.sortBy] });
        const filterArgs = computed(() => {
            let filter = '';
            if (advancedArgs.dateFrom) {
                filter += `timestamp >= ${Math.round(advancedArgs.dateFrom / 1000)}`;
            }
            if (advancedArgs.dateTo) {
                if (filter) {
                    filter += ' AND ';
                }
                filter += `timestamp <= ${Math.round(advancedArgs.dateTo / 1000)}`;
            }
            return filter ? { filter } : {};
        });
        const emit = __emit;
        theme().attachBreakpointListener(onResizeBreakpoint);
        onUnmounted(() => {
            theme().removeBreakpointListener(onResizeBreakpoint);
        });
        watch(() => query.value, async (after, before) => {
            if (after !== before) {
                if (after === null || after === void 0 ? void 0 : after.length) {
                    search();
                }
                else {
                    results.value = [];
                }
                emit('queryChange', after || '');
            }
        });
        watch(() => activeIndexUid.value, async (after, before) => {
            if (after !== before && query.value) {
                search();
            }
            emit('indexChange', after || null);
            advancedArgs.topicsFilter = null;
            advancedArgs.activeStaticFacets = [];
        });
        const genericWatcher = (after, before) => {
            if (after !== before && query.value) {
                search();
            }
        };
        watch(() => advancedArgs.isTitleExclusive, genericWatcher);
        watch(() => advancedArgs.sortBy, genericWatcher);
        watch(() => advancedArgs.dateFrom, (after, before) => {
            if (after !== before && query.value) {
                search();
                emit('dateFromChange', after);
            }
        });
        watch(() => advancedArgs.dateTo, (after, before) => {
            if (after !== before && query.value) {
                search();
                emit('dateToChange', after);
            }
        });
        watch(() => advancedArgs.activeStaticFacets, (after, before) => {
            emit('staticFacetsChange', after);
            const diff = [].concat(after.filter(f => !before.includes(f)), before.filter(f => !after.includes(f))).filter(f => f);
            for (const facet of diff) {
                const [indexUid, facetId, value] = facet.split('/');
                reloadIndex(indexUid);
            }
        });
        watch(() => { var _a; return (_a = advancedArgs.topicsFilter) === null || _a === void 0 ? void 0 : _a.selected; }, () => {
            var _a;
            emit('topicsChange', ((_a = advancedArgs.topicsFilter) === null || _a === void 0 ? void 0 : _a.selected) || []);
            if (activeIndex.value) {
                reloadIndex(activeIndex.value.uid);
            }
        });
        if (!props.withoutInput && props.autoFocusInput) {
            nextTick(() => {
                var _a;
                (_a = ownQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
        if (query.value) {
            search();
        }
        function onResizeBreakpoint(event) {
            state.mediaSize = event.detail.size;
        }
        async function search() {
            if (state.searching) {
                state.searchInQueue = true;
                return;
            }
            state.searching = true;
            try {
                if (activeIndexUid.value) {
                    const indexUid = activeIndexUid.value;
                    const requestIndexUid = advancedArgs.isTitleExclusive ? getTXIndexUid(indexUid) : indexUid;
                    const indexArgs = getStandAloneSearchArgsDefaults(requestIndexUid);
                    applyStaticFacetsFilters(indexUid, indexArgs);
                    const result = await api.search(requestIndexUid, Object.assign(Object.assign(Object.assign(Object.assign({}, indexArgs), sortArgs.value), filterArgs.value), { q: query.value }));
                    results.value = [{
                            indexUid,
                            indexData: indexes.find(index => index.uid === indexUid),
                            result,
                        }];
                }
                else {
                    const indexesArgs = getMultiSearchArgsDefaults(advancedArgs.isTitleExclusive);
                    for (const index of indexes) {
                        if (indexesArgs[index.uid] && index.staticFacets.length) {
                            applyStaticFacetsFilters(index.uid, indexesArgs[index.uid]);
                        }
                    }
                    const resp = await api.multiSearch(Object.assign(Object.assign(Object.assign({}, sortArgs.value), filterArgs.value), { q: query.value, limit: 3 }), indexesArgs);
                    results.value = Object.entries(resp).map(([indexUid, result]) => {
                        const primeIndexUid = getPrimeIndexUid(indexUid);
                        return {
                            indexUid: primeIndexUid,
                            indexData: indexes.find(index => index.uid === primeIndexUid),
                            result,
                        };
                    });
                }
            }
            catch (err) {
                console.error(err);
            }
            state.searching = false;
            if (state.searchInQueue) {
                state.searchInQueue = false;
                await search();
            }
            emit('searchResult', results.value);
        }
        function applyStaticFacetsFilters(indexUid, args) {
            var _a;
            if (typeof args.filter === 'string') {
                args.filter = [args.filter];
            }
            else if (!args.filter) {
                args.filter = [];
            }
            if ((_a = advancedArgs.topicsFilter) === null || _a === void 0 ? void 0 : _a.selected.length) {
                args.filter.push(`${advancedArgs.topicsFilter.attribute} IN ['${advancedArgs.topicsFilter.selected.map(v => v.id).join(`', '`)}']`);
            }
            const activeStaticFacets = advancedArgs.activeStaticFacets
                .filter(facet => facet.startsWith(indexUid))
                .map(facet => {
                const [indexUid, id, value] = facet.split('/');
                const index = indexes.find(i => i.uid === indexUid);
                const def = index === null || index === void 0 ? void 0 : index.staticFacets.find(f => f.id === id);
                return def ? {
                    attribute: def.attribute,
                    value,
                } : null;
            })
                .reduce((acc, f) => {
                if (!f) {
                    return acc;
                }
                if (!acc[f.attribute]) {
                    acc[f.attribute] = [];
                }
                acc[f.attribute].push(f.value);
                return acc;
            }, {});
            const activeKeys = Object.keys(activeStaticFacets);
            if (activeKeys.length) {
                for (const key of activeKeys) {
                    args.filter.push(`${key} IN ['${activeStaticFacets[key].join(`', '`)}']`);
                }
            }
        }
        async function reloadIndex(indexUid) {
            var _a;
            const requestIndexUid = advancedArgs.isTitleExclusive ? getTXIndexUid(indexUid) : indexUid;
            const indexArgs = activeIndexUid.value
                ? getStandAloneSearchArgsDefaults(requestIndexUid)
                : getMultiSearchArgsDefaults(advancedArgs.isTitleExclusive)[indexUid];
            applyStaticFacetsFilters(indexUid, indexArgs);
            const args = Object.assign(Object.assign(Object.assign(Object.assign({}, indexArgs), sortArgs.value), filterArgs.value), { q: query.value });
            const resultsEntry = results.value.find(r => r.indexUid === indexUid);
            if ((_a = resultsEntry === null || resultsEntry === void 0 ? void 0 : resultsEntry.result) === null || _a === void 0 ? void 0 : _a.hits.length) {
                args.limit = Math.max(args.limit || 0, resultsEntry.result.hits.length);
            }
            const resp = await api.search(requestIndexUid, args);
            results.value = results.value.map(entry => {
                if (entry.indexUid === indexUid) {
                    return Object.assign(Object.assign({}, entry), { result: resp });
                }
                return entry;
            });
        }
        function canLoadMore(response) {
            return Math.max(response.limit, response.hits.length) < response.estimatedTotalHits;
        }
        async function loadMore(indexUid, prevResponse) {
            const requestIndexUid = advancedArgs.isTitleExclusive ? getTXIndexUid(indexUid) : indexUid;
            const indexArgs = getStandAloneSearchArgsDefaults(requestIndexUid);
            applyStaticFacetsFilters(indexUid, indexArgs);
            const resp = await api.search(requestIndexUid, Object.assign(Object.assign(Object.assign(Object.assign({}, indexArgs), sortArgs.value), filterArgs.value), { q: query.value, offset: prevResponse.hits.length }));
            results.value = results.value.map(entry => {
                if (entry.indexUid === indexUid) {
                    return Object.assign(Object.assign({}, entry), { result: Object.assign(Object.assign({}, resp), { hits: [
                                ...prevResponse.hits,
                                ...resp.hits,
                            ] }) });
                }
                return entry;
            });
        }
        function onIndexSelectChange(event) {
            const select = event.target;
            activeIndexUid.value = select.value;
        }
        function emptyOwnQuery() {
            var _a;
            ownQuery.value = '';
            (_a = ownQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
        }
        function showTopicSelectionUI() {
            var _a, _b;
            topicsState.search = '';
            if ((_a = advancedArgs.topicsFilter) === null || _a === void 0 ? void 0 : _a.selected.length) {
                topicsState.selected = advancedArgs.topicsFilter.selected;
            }
            (_b = topicsModal.value) === null || _b === void 0 ? void 0 : _b.show();
        }
        function applyTopicsSelection() {
            var _a, _b, _c;
            if (topicsState.selected.length && ((_b = (_a = activeIndex.value) === null || _a === void 0 ? void 0 : _a.topicsData) === null || _b === void 0 ? void 0 : _b.attribute)) {
                advancedArgs.topicsFilter = {
                    attribute: activeIndex.value.topicsData.attribute,
                    selected: topicsState.selected,
                };
            }
            else {
                advancedArgs.topicsFilter = null;
            }
            topicsState.search = '';
            topicsState.selected = [];
            (_c = topicsModal.value) === null || _c === void 0 ? void 0 : _c.dismiss();
        }
        function onTopicsModalShown() {
            nextTick(() => {
                var _a;
                (_a = topicsModalInput.value) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
        function onTopicSelectionChange(event, entry) {
            if (event.target.checked) {
                topicsState.selected.push(entry);
            }
            else {
                topicsState.selected = topicsState.selected.filter(v => v.id !== entry.id);
            }
        }
        function prepareModalTopics(values = []) {
            if (topicsState.search.length < 2) {
                return values.map(val => (Object.assign(Object.assign({}, val), { visible: true })));
            }
            const words = topicsState.search.toLowerCase().split(/[\s._-]/).filter(w => w).slice(0, 10);
            return values.map(val => {
                const visible = words.some(w => val.label.toLowerCase().indexOf(w) >= 0);
                return Object.assign(Object.assign({}, val), { visible });
            });
        }
        function isFacetEntrySelected(indexUid, facet, facetEntry) {
            const uid = `${indexUid}/${facet.id}/${facetEntry.id}`;
            return advancedArgs.activeStaticFacets.includes(uid);
        }
        function onFacetEntryChange(event, indexUid, facet, facetEntry) {
            const uid = `${indexUid}/${facet.id}/${facetEntry.id}`;
            if (event.target.checked) {
                advancedArgs.activeStaticFacets = [...advancedArgs.activeStaticFacets, uid];
            }
            else {
                advancedArgs.activeStaticFacets = advancedArgs.activeStaticFacets.filter(facet => facet !== uid);
            }
        }
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (!_ctx.withoutInput)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "siteSearch-inputField-input",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((ownQuery).value = $event)),
                                    ref_key: "ownQueryInputEl",
                                    ref: ownQueryInputEl
                                }, null, 512), [
                                    [_vModelText, ownQuery.value]
                                ]),
                                _createVNode(_unref(ThemeIcon), {
                                    class: "siteSearch-inputField-icon",
                                    name: "magnifying-glass"
                                }),
                                (ownQuery.value)
                                    ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                        key: 0,
                                        class: "siteSearch-inputField-emptyBtn",
                                        "wca-title": "Empty search",
                                        icon: "times-round-outline",
                                        color: "primary",
                                        fill: "none",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (emptyOwnQuery()))
                                    }))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, [
                            (state.mediaSize <= _unref(ThemeMediaSize).Medium)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("select", { onChange: onIndexSelectChange }, [
                                        _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Alla", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(indexes), (index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: index.uid,
                                                value: index.uid,
                                                selected: activeIndexUid.value === index.uid
                                            }, _toDisplayString(index.label), 9, _hoisted_6));
                                        }), 128))
                                    ], 32),
                                    _createVNode(_unref(ThemeIcon), { name: "chevron-down" })
                                ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_unref(ThemeButton), {
                                        title: "Alla",
                                        class: _normalizeClass({ 'is--chosen': !activeIndexUid.value }),
                                        color: !activeIndexUid.value ? 'primary' : 'light',
                                        size: _ctx.advanced ? 'normal' : 'small',
                                        onClick: _cache[2] || (_cache[2] = ($event) => (activeIndexUid.value = null))
                                    }, null, 8, ["class", "color", "size"]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(indexes), (index) => {
                                        return (_openBlock(), _createBlock(_unref(ThemeButton), {
                                            key: index.uid,
                                            title: index.label,
                                            class: _normalizeClass({ 'is--chosen': activeIndexUid.value === index.uid }),
                                            color: activeIndexUid.value === index.uid ? 'primary' : 'light',
                                            size: _ctx.advanced ? 'normal' : 'small',
                                            onClick: ($event) => (activeIndexUid.value = index.uid)
                                        }, null, 8, ["title", "class", "color", "size", "onClick"]));
                                    }), 128))
                                ], 64))
                        ]),
                        (_ctx.advanced)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("label", _hoisted_9, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((advancedArgs.isTitleExclusive) = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, advancedArgs.isTitleExclusive]
                                        ]),
                                        _createVNode(_unref(ThemeIcon), { name: "check" }),
                                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Sök endast i rubriker", -1))
                                    ])
                                ]),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["siteSearch-adv-control for--topics", {
                                            'is--disabled': !activeIndex.value || !((_b = (_a = activeIndex.value.topicsData) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.length),
                                            'is--active': (_c = advancedArgs.topicsFilter) === null || _c === void 0 ? void 0 : _c.selected.length
                                        }])
                                }, [
                                    _cache[12] || (_cache[12] = _createElementVNode("label", null, "Ämne", -1)),
                                    _createElementVNode("button", {
                                        class: "siteSearch-fauxSelect",
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (showTopicSelectionUI()), ["prevent"]))
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(((_d = advancedArgs.topicsFilter) === null || _d === void 0 ? void 0 : _d.selected.length) ? `${(_e = advancedArgs.topicsFilter) === null || _e === void 0 ? void 0 : _e.selected.length} ${((_f = advancedArgs.topicsFilter) === null || _f === void 0 ? void 0 : _f.selected.length) === 1 ? 'valt' : 'valda'}` : 'Välj...'), 1),
                                        _createVNode(_unref(ThemeIcon), { name: "chevron-down" })
                                    ])
                                ], 2),
                                _createElementVNode("div", _hoisted_10, [
                                    _cache[13] || (_cache[13] = _createElementVNode("label", null, "Publiceringsdatum", -1)),
                                    (VueDatePicker.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _createVNode(_unref(VueDatePicker), {
                                                modelValue: advancedArgs.dateFrom,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((advancedArgs.dateFrom) = $event)),
                                                placeholder: "Från datum",
                                                "model-type": "timestamp",
                                                format: "yyyy-MM-dd",
                                                "week-numbers": "local",
                                                "min-date": "2000-01-01",
                                                "max-date": advancedArgs.dateTo ? new Date(advancedArgs.dateTo) : new Date(),
                                                "enable-time-picker": false,
                                                locale: "sv",
                                                "cancel-text": "Avbryt",
                                                "select-text": "Välj",
                                                "now-button-label": "Idag",
                                                "week-num-name": "v."
                                            }, null, 8, ["modelValue", "max-date"]),
                                            _createVNode(_unref(ThemeIcon), { name: "arrow-right-long" }),
                                            _createVNode(_unref(VueDatePicker), {
                                                modelValue: advancedArgs.dateTo,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((advancedArgs.dateTo) = $event)),
                                                placeholder: "Till datum",
                                                "model-type": "timestamp",
                                                format: "yyyy-MM-dd",
                                                "week-numbers": "local",
                                                "min-date": advancedArgs.dateFrom ? new Date(advancedArgs.dateFrom) : '',
                                                "max-date": new Date(),
                                                "enable-time-picker": false,
                                                locale: "sv",
                                                "cancel-text": "Avbryt",
                                                "select-text": "Välj",
                                                "now-button-label": "Idag",
                                                "week-num-name": "v."
                                            }, null, 8, ["modelValue", "min-date", "max-date"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _cache[14] || (_cache[14] = _createElementVNode("label", null, "Sortera efter", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((advancedArgs.sortBy) = $event))
                                    }, [
                                        _createElementVNode("option", {
                                            value: SortBy.Relevance,
                                            selected: advancedArgs.sortBy === SortBy.Relevance
                                        }, _toDisplayString(SortByLabels[SortBy.Relevance]), 9, _hoisted_13),
                                        _createElementVNode("option", {
                                            value: SortBy.DateAsc,
                                            selected: advancedArgs.sortBy === SortBy.DateAsc
                                        }, _toDisplayString(SortByLabels[SortBy.DateAsc]), 9, _hoisted_14),
                                        _createElementVNode("option", {
                                            value: SortBy.DateDesc,
                                            selected: advancedArgs.sortBy === SortBy.DateDesc
                                        }, _toDisplayString(SortByLabels[SortBy.DateDesc]), 9, _hoisted_15)
                                    ], 512), [
                                        [_vModelSelect, advancedArgs.sortBy]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        ((_g = advancedArgs.topicsFilter) === null || _g === void 0 ? void 0 : _g.selected.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advancedArgs.topicsFilter.selected, (entry) => {
                                    return (_openBlock(), _createBlock(_unref(ThemeButton), {
                                        type: "button",
                                        class: "siteSearch-topicCap",
                                        title: entry.label,
                                        "wca-title": "Ta bort ämnet",
                                        "icon-after": "times",
                                        size: "tiny",
                                        fill: "outline",
                                        color: "neutral",
                                        variation: "chip",
                                        onClick: ($event) => (advancedArgs.topicsFilter.selected = advancedArgs.topicsFilter.selected.filter(v => v.id !== entry.id))
                                    }, null, 8, ["title", "onClick"]));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (results.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            (_ctx.linkToSearchPage)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_unref(ThemeButton), {
                                        type: "link",
                                        href: _unref(Search).buildUrl({
                                            query: query.value || '',
                                            indexUid: activeIndexUid.value,
                                        }).toString(),
                                        title: `Visa fler resultat för <mark>${query.value}</mark>`,
                                        "wca-title": "Visa fler resultat",
                                        fill: "text",
                                        "icon-after": "arrow-right-long"
                                    }, null, 8, ["href", "title"])
                                ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (entry) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: entry.indexUid
                                }, [
                                    (entry.result.hits.length || advancedArgs.activeStaticFacets.some(f => f.startsWith(entry.indexUid)))
                                        ? (_openBlock(), _createElementBlock("section", {
                                            key: 0,
                                            class: _normalizeClass(["siteSearch-results-entry", 'is--' + entry.indexUid])
                                        }, [
                                            _createElementVNode("header", _hoisted_19, [
                                                _createVNode(_unref(ThemeIcon), {
                                                    name: entry.indexData.icon
                                                }, null, 8, ["name"]),
                                                _createElementVNode("h3", _hoisted_20, _toDisplayString(entry.indexData.label), 1),
                                                (entry.indexData.landingPageUrl)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createVNode(_unref(ThemeIcon), {
                                                            class: "siteSearch-results-headerArrow",
                                                            name: "arrow-right-long"
                                                        }),
                                                        _createElementVNode("a", {
                                                            class: "siteSearch-results-headerLink",
                                                            href: entry.indexData.landingPageUrl
                                                        }, "Gå till sidan", 8, _hoisted_21)
                                                    ], 64))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("span", _hoisted_22, [
                                                    (entry.result.estimatedTotalHits >= 1000)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(" 999+ resultat ")
                                                        ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(_toDisplayString(entry.result.estimatedTotalHits) + " resultat", 1)
                                                        ], 64))
                                                ])
                                            ]),
                                            (entry.indexData.staticFacets.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.indexData.staticFacets, (facet) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                            _createElementVNode("h4", _hoisted_25, _toDisplayString(facet.label) + ":", 1),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facet.values, (facetEntry) => {
                                                                return (_openBlock(), _createElementBlock("label", _hoisted_26, [
                                                                    _createElementVNode("input", {
                                                                        type: "checkbox",
                                                                        checked: isFacetEntrySelected(entry.indexUid, facet, facetEntry),
                                                                        onChange: ($event) => (onFacetEntryChange($event, entry.indexUid, facet, facetEntry))
                                                                    }, null, 40, _hoisted_27),
                                                                    _createVNode(_unref(ThemeIcon), { name: "check" }),
                                                                    _createElementVNode("span", {
                                                                        innerHTML: facetEntry.label
                                                                    }, null, 8, _hoisted_28)
                                                                ]));
                                                            }), 256))
                                                        ]));
                                                    }), 256))
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("ul", _hoisted_29, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.result.hits, (hit) => {
                                                    return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(indexesCardComponents)[entry.indexUid]), {
                                                        class: "siteSearch-hit",
                                                        key: hit.id,
                                                        document: hit
                                                    }, null, 8, ["document"]));
                                                }), 128))
                                            ]),
                                            (canLoadMore(entry.result))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    _createVNode(_unref(ThemeButton), {
                                                        title: "Ladda fler",
                                                        variation: "chip",
                                                        size: "small",
                                                        fill: "outline",
                                                        color: "neutral",
                                                        icon: "loading",
                                                        state: state.searching ? 'loading' : '',
                                                        onClick: ($event) => (loadMore(entry.indexUid, entry.result))
                                                    }, null, 8, ["state", "onClick"])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ], 2))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    (!hasResults.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (query.value.length >= _unref(MIN_INPUT_LENGTH))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("p", null, [
                                        _cache[16] || (_cache[16] = _createTextVNode("Din sökning på ")),
                                        _createElementVNode("em", null, _toDisplayString(query.value), 1),
                                        _cache[17] || (_cache[17] = _createTextVNode(" gav inga resultat")),
                                        (activeIndex.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                                _cache[15] || (_cache[15] = _createTextVNode(" i ")),
                                                _createElementVNode("em", null, _toDisplayString(activeIndex.value.label), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[18] || (_cache[18] = [
                                    _createElementVNode("p", null, "Skriv minst 2 tecken för att börja söka", -1)
                                ])))
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                (activeIndex.value && ((_j = (_h = activeIndex.value.topicsData) === null || _h === void 0 ? void 0 : _h.values) === null || _j === void 0 ? void 0 : _j.length))
                    ? (_openBlock(), _createBlock(_unref(ThemeModal), {
                        key: 0,
                        ref_key: "topicsModal",
                        ref: topicsModal,
                        classes: "topicsModal",
                        title: `Välj ${(_k = activeIndex.value.topicsData) === null || _k === void 0 ? void 0 : _k.label}`,
                        actions: [
                            { title: 'Avbryt', handler: 'dismiss', color: 'neutral', iconAfter: 'times' },
                            {
                                title: (topicsState === null || topicsState === void 0 ? void 0 : topicsState.selected.length) ? `Välj ${topicsState.selected.length}st` : 'Välj',
                                handler: () => applyTopicsSelection(),
                                iconAfter: 'check',
                                fill: 'solid'
                            },
                        ],
                        onShown: onTopicsModalShown
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createElementVNode("div", _hoisted_34, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        ref_key: "topicsModalInput",
                                        ref: topicsModalInput,
                                        class: _normalizeClass({ 'is--active': topicsState.search }),
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((topicsState.search) = $event))
                                    }, null, 2), [
                                        [_vModelText, topicsState.search]
                                    ]),
                                    _createVNode(_unref(ThemeIcon), { name: "magnifying-glass" })
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareModalTopics((_a = activeIndex.value.topicsData) === null || _a === void 0 ? void 0 : _a.values), (entry) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_36, [
                                            _createElementVNode("input", {
                                                type: "checkbox",
                                                checked: topicsState.selected.findIndex(v => v.id === entry.id) >= 0,
                                                onChange: ($event) => (onTopicSelectionChange($event, entry))
                                            }, null, 40, _hoisted_37),
                                            _createVNode(_unref(ThemeIcon), { name: "check" }),
                                            _createElementVNode("span", {
                                                innerHTML: entry.label
                                            }, null, 8, _hoisted_38)
                                        ], 512)), [
                                            [_vShow, entry.visible]
                                        ]);
                                    }), 256))
                                ]),
                                _createVNode(_unref(ThemeButton), {
                                    class: "topicsModal-uncheckBtn",
                                    title: "Avmarkera alla",
                                    color: "light",
                                    size: "small",
                                    disabled: !(topicsState === null || topicsState === void 0 ? void 0 : topicsState.selected.length),
                                    onClick: _cache[9] || (_cache[9] = ($event) => (topicsState.selected = []))
                                }, null, 8, ["disabled"])
                            ];
                        }),
                        _: 1
                    }, 8, ["title", "actions"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
